import { useLanguage } from '@/lib/i18n';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin } from 'lucide-react';

const ContactCTA = () => {
  const { tr } = useLanguage();

  return (
    <section id="contact" className="py-6 md:py-8 bg-primary">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-2xl mx-auto"
        >
          <h2 className="font-heading text-xl md:text-2xl font-bold text-primary-foreground">{tr('cta.title')}</h2>
          <p className="mt-1.5 text-primary-foreground/80 text-sm md:text-base">{tr('cta.subtitle')}</p>

          {/* Social Messenger Buttons */}
          <div className="mt-4 flex flex-wrap gap-3 justify-center mb-4">
            <a href="https://wa.me/4915678680657" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="hover:scale-105 transition-transform">
              <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" className="w-8 h-8" />
            </a>
            <a href="viber://chat?number=%2B4915678680657" target="_blank" rel="noopener noreferrer" aria-label="Viber" className="hover:scale-105 transition-transform">
              <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/viber.svg" alt="Viber" className="w-8 h-8" />
            </a>
            <a href="https://t.me/+4915678680657" target="_blank" rel="noopener noreferrer" aria-label="Telegram" className="hover:scale-105 transition-transform">
              <img src="https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg" alt="Telegram" className="w-8 h-8" />
            </a>
            <a href="https://www.facebook.com/viamedicabalkan" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:scale-105 transition-transform">
              <img src="https://upload.wikimedia.org/wikipedia/commons/1/16/Facebook-icon-1.png" alt="Facebook" className="w-8 h-8" />
            </a>
          </div>
          <div className="grid sm:grid-cols-3 gap-3 text-primary-foreground/90">
            <div className="flex flex-col items-center gap-1.5">
              <MapPin className="w-4 h-4" />
              <p className="text-xs md:text-sm">Teisenbergstraße 1<br />83395 Freilassing<br />Deutschland</p>
            </div>
            <div className="flex flex-col items-center gap-1.5">
              <Phone className="w-4 h-4" />
              <p className="text-xs md:text-sm">+49 156 7868 0657<br />+49 8654 4579 967</p>
            </div>
            <div className="flex flex-col items-center gap-1.5">
              <Mail className="w-4 h-4" />
              <p className="text-xs md:text-sm">info@via-medica-balkan.de<br />www.via-medica-balkan.de</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactCTA;
